import React from 'react';
import FilterMetricsSelector from '../../../../../../../common/components/Form/filterInputs/MetricsSelect';
import { historyRangeOptions, realTimeRangeOptions } from '../options';

function TimeRange({ value, onChange, isRealTime = false }) {
  return (
    <FilterMetricsSelector
      options={isRealTime ? realTimeRangeOptions : historyRangeOptions}
      className="filter filter-aggregation"
      label={isRealTime ? 'Time Range:' : 'Interval:'}
      value={value}
      name={isRealTime ? 'timeRange' : 'interval'}
      onChange={onChange}
    />
  );
}

export default TimeRange;
